/* eslint-disable vue/multi-word-component-names */

import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';

import ConfirmDialog from 'primevue/confirmdialog';
import DynamicDialog from 'primevue/dynamicdialog';
import Checkbox from 'primevue/checkbox';

const setPrimeVue = (app) => {
  app.use(PrimeVue, {
    theme: {
      preset: Aura,
    },
  });
  app.use(ConfirmationService);
  app.use(DialogService);
  app.component('ConfirmDialog', ConfirmDialog);
  app.component('DynamicDialog', DynamicDialog);
  app.component('Checkbox', Checkbox);
};

export default setPrimeVue;
